// Popup pre Internet Explorer
var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
var trident = ua.indexOf('Trident/');
if(msie > 0 || trident > 0){
   alert("Internet Explorer nie je podporovaný prehliadač. Aktualizujte prosím na modernejšiu variantu, napríklad Google Chrome, atď. Ďakujeme za pochopenie.");
};